var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{staticClass:"md-layout-item md-large-size-60 md-medium-size-80 md-xlarge-size-50 md-size-100 px-0 flex items-center"},[_c('information',{attrs:{"information":_vm.information}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }